import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';


interface IInputStringaProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: string;
}

export class InputStringa extends BasePureComponent<IInputStringaProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string")) {
            etichetta = <label>{Trad.Trad(this.props.Etichetta)}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <input
                    type="text"
                    className="form-control"
                    value={this.props.Valore}
                    name={this.props.Name}
                    id={this.props.Id}
                    onChange={this.props.OnChange}
                    required={this.props.Richiesto != undefined ? this.props.Richiesto : false}
                    onBlur={this.props.OnBlur}
                    readOnly={this.props.Scrittura != undefined ? !this.props.Scrittura : false} />
                <span className="kt-input-icon__icon kt-input-icon__icon--right">
                    <span>
                        <i className="la la-edit"></i>
                    </span>
                </span>
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputStringa.tsx